module.exports = __webpack_public_path__ + "img/way_c.00d32577.jpg";